// 屏蔽 Ant Design Portal 与 React reconciliation 竞态导致的 removeChild DOM 异常
(function () {
  var _removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    try { return _removeChild.call(this, child); }
    catch (e) {
      if (e.name === 'NotFoundError' || String(e.message || '').includes('removeChild')) {
        return child; // 节点已被 React 清理，静默忽略
      }
      throw e;
    }
  };
})();

import { Component } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, componentStack: '' };
  }
  static getDerivedStateFromError(error) {
    // 过滤 Ant Design 的 removeChild 竞态错误，不展示错误界面
    const msg = String(error?.message || '');
    if (msg.includes('removeChild')) return null;
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    const msg = String(error?.message || '');
    if (msg.includes('removeChild')) return; // 静默
    console.error('React Error Boundary caught:', error, errorInfo);
    this.setState({ componentStack: errorInfo?.componentStack || '' });
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{padding: 20, color: 'red', fontFamily: 'monospace'}}>
          <h3>React Error</h3>
          <pre>{this.state.error.message}</pre>
          <pre style={{marginTop:12,fontSize:11,color:'#666'}}>{this.state.componentStack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

window.onerror = function (msg, url, line, col, err) {
  var message = String(msg || '');
  if (message.includes('removeChild')) return true; // 静默吞掉
  console.error('Global onerror:', msg, err);
};

createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
